import * as React from 'react';
import { createNewGame, GameBoard, playTurn } from 'src/models/Mahjong/Game';
import { Hand } from './Hand';
import { DiscardPile } from './DiscardPile';
import { TileImage } from './TileImage';

export function GameTest(): JSX.Element {
    const [game, setGame] = React.useState<GameBoard | null>(null);

    React.useEffect(() => {
        setGame(createNewGame());
    }, []);

    const handleReset = () => {
        setGame(createNewGame());
    };

    const handleDiscard = (playerIndex: number, tileIndex: number) => {
        if (game && game.currentTurn === playerIndex) {
            const updatedGame = playTurn(game, tileIndex);
            setGame(updatedGame);
        }
    };

    if (!game) {
        return <div></div>;
    }

    return (
        <div className="flex-vertical align-center gap-2 ma-2 flex-fill">
            <div className="flex-absolute justify-between">
                <h2 className="white-text">Mahjong Game Test</h2>

                <button
                    onClick={handleReset}
                    className="navlink-background white-text p-2 pointer"
                >
                    Reset Game
                </button>
            </div>

            <div className="flex flex-wrap gap-4 white-text width-100 justify-between">
                <div className="basic-box flex-vertical gap-1">
                    <h4 className="ma-0">Game Info</h4>
                    <div>Round: {game.roundWind.charAt(0).toUpperCase() + game.roundWind.slice(1)}</div>
                    <div>Wall Remaining: {game.wall.length}</div>
                    <div>State: {game.gameState}</div>
                </div>

                <div className="basic-box white-text flex-fill mt-2">
                    <h4 className="ma-0 mb-1">Wall</h4>
                    <div className="flex-absolute" style={{ paddingLeft: '20px' }}>
                        {game.wall.map((tile, index) => (
                            <div key={tile.id} style={{ marginLeft: '-20px' }}>
                                <TileImage tile={tile} height={40} faceDown={true} />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="basic-box flex-vertical gap-1">
                    <h4 className="ma-0">Dora Indicators</h4>
                    {game.doraIndicators && (
                        <Hand
                            tiles={game.doraIndicators}
                            tileHeight={40}
                            faceDown={(_, index) => index > 0}
                        />
                    )}
                </div>
            </div>

            <div className="flex-vertical gap-2 width-100 mt-2">
                {game.players.map((player, index) => (
                    <div key={index} className="flex-absolute gap-2">
                        <div
                            className="white-text basic-box flex-fill"
                            style={{ border: game.currentTurn === index ? '2px solid #ffd700' : '1px solid transparent' }}
                        >
                            <div className="flex justify-between align-center mb-1">
                                <h3 className="ma-0">
                                    Player {index + 1}: {player.wind.charAt(0).toUpperCase() + player.wind.slice(1)}
                                </h3>
                                <span className="ma-0 font-weight-bold">{player.points} pts</span>
                            </div>
                            <Hand
                                tiles={player.hand}
                                isInteractive={game.currentTurn === index}
                                onTileClick={(_, tileIndex) => handleDiscard(index, tileIndex)}
                                faceDown={game.currentTurn !== index}
                            />
                        </div>
                        <div className="white-text basic-box flex-fill" style={{ maxWidth: '200px' }}>
                            <h4 className="ma-0 mb-1" style={{ fontSize: '0.8em' }}>Discards</h4>
                            <DiscardPile tiles={player.discards} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
